import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import styles from "./MasterBudget.module.css";
import { Button, Form, Input, Popconfirm, Table, InputNumber, Modal, Select, Switch, Layout, Space} from 'antd';
import { Content } from "antd/lib/layout/layout";
import { DeleteCategoryDepartment, DeleteMasterBudget, GetCategoryDepartment, GetMasterBudget, InsertCategoryDepartment, InsertMasterBudget, UpdateMasterBudget } from "../../../Services/e-pro/CatalogMasterDataService";
import { IProductItem } from "../../../IRequestModel/ECatalog/IProductItemModel";
import { GetDepartment } from "../../../Services/DepartmentService";
import { SearchCatalogItem } from "../../../Services/e-pro/EcatalogService";
import { MapsDataToProductObject } from "../../../Helper/ECatalogHelper";
import { useUserContext } from "../../../Context/UserContext";
import Swal from "sweetalert2";

import { SearchOutlined } from '@ant-design/icons';
import type { InputRef } from 'antd';
import type { ColumnsType, ColumnType } from 'antd/es/table';
import type { FilterConfirmProps } from 'antd/es/table/interface';
import { GetDivision } from "../../../Services/DivisonService";
import DatePicker from '../../../Helper/DatePicker';
import locale from 'antd/es/date-picker/locale/th_TH';
import dayjs, { Dayjs } from 'dayjs';
import th from 'dayjs/locale/th';
import type { PickerProps } from 'antd/lib/date-picker/generatePicker';
import Highlighter from 'react-highlight-words';
import { GetSection } from "../../../Services/SectionService";
import { GetPermissionByEmpId } from "../../../Services/RoleServices";
import { GetAllDynamic } from "../../../Services/DynamicService";

export declare type DatePickerProps = PickerProps<Dayjs>;
const datePickerTh = {
    ...locale,
    lang: {
        ...locale.lang,
        yearFormat: 'BBBB',
        dateFormat: 'M/D/BBBB',
        dateTimeFormat: 'M/D/BBBB HH:mm:ss',
    },
    dateFormat: 'BBBB-MM-DD',
    dateTimeFormat: 'BBBB-MM-DD HH:mm:ss',
    weekFormat: 'BBBB-wo',
    monthFormat: 'BBBB-MM',
};
interface Values {
    BudgetID? : number;
    DepartmentCode: string;
    DivisionCode?: string;
    SectionCode?: string;
    IsUnLimit: boolean;
    TotalBudget: number;
    CurrentBudget: number;
    BudgetYear: any;
    IsActive: boolean;
    CreatedBy: string;
    ModifiedBy: string;
}

interface DataType {
    key: React.Key;
    BudgetID : number;
    DepartmentCode: string;
    DivisionCode: string;
    SectionCode: string;
    IsUnLimit: boolean;
    TotalBudget: number;
    CurrentBudget: number;
    BudgetYear: string;
    IsActive: boolean;
    CreatedBy: string;
    ModifiedBy: string;
  }
  
  type DataIndex = keyof DataType;
  export type OrgDatasource = {
    DepartmentSource?: any[];
    DivisionSource?: any[];
    SectionSource?: any[];
  };
const MasterBudget = () => {
    const [userData] = useUserContext();
    const [openPopupEdit, setOpenPopupEdit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataDepartmentList, setDataDepartmentList] = useState<any>();
    const [dataDivisionList, setDataDivisionList] = useState<any>();
    const [dataSectionList, setDataSectionList] = useState<any>();
    

    const [dataSource, setDataSource] = useState<any[]>([]);
    const [dataSourceDetail, setDataSourceDetail] = useState<Values>();

    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [isDeptAdmin, setIsDeptAdmin] = useState(false);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const [deptFilter, setDeptFilter] = useState([]);
    const [departmentSource, setDepartmentSource] = useState<any[]>([]);
    const [divisionSource, setDivisionSource] = useState<any[]>([]);
    const [sectionSource, setSectionSourcee] = useState<any[]>([]);

    const searchInput = useRef<InputRef>(null);
    

    const onPopupCreate = async (values: Values) => {
        //console.log('Received values of form: ', values);
        setConfirmLoading(true);
        let objectInsert = values;

        objectInsert.BudgetYear = values.BudgetYear.locale(th).format('BBBB');
        objectInsert.DivisionCode = values.DivisionCode === '' ? undefined : values.DivisionCode;
        objectInsert.SectionCode = values.SectionCode === '' ? undefined : values.SectionCode;
        if (values.BudgetID === undefined || values.BudgetID === 0)
            await InsertMasterBudget(objectInsert);
        else
            await UpdateMasterBudget(objectInsert);
        
        form.resetFields();
        setConfirmLoading(false);
        setOpenPopupEdit(false);
          
        fetchDataMasterBudget();
    };

    const onDeleteItemClick = async(value) => {
        Swal.fire({
            title: "ยืนยันการลบรายการ" ,
            text: value.DepartmentName ,
            //icon: "question",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ไม่ยืนยัน",
            showCancelButton: true,
            confirmButtonColor: "#1890ff",
            cancelButtonColor: "#c95558",
        }).then(async (result) => {
          if (result.isConfirmed) {
            setLoading(true);
            await DeleteMasterBudget(value);
            fetchDataMasterBudget();
            setLoading(false);
          }
        });
    }
    useEffect(() => {
        checkPermissionUser();
    }, []);

    useEffect(() => {

        fetchDataMasterBudget();
       
    }, [deptFilter]);

    useEffect(() => {
        processMasterData();
    }, [dataSource])


    const processMasterData = async () => {
        await fetchMasterDepartment();
        await fetchMasterDivision();
        await fetchMasterSection();
        setDepartmentSource(bindingValueToDropdown("DEP"));
    };

    const checkPermissionUser = async () => {
        const dataPermission = await GetPermissionByEmpId({
            EmployeeId: userData.EmployeeId,
          });
      
          let isSuperAdmin: boolean = false;
          let isDeptAdmin: boolean = false;
          let canEdit: boolean = false;
          let deptFilterArray = [];
          //let permissions: any[] = await GetRolePermission();
          let roles: any[] = await GetAllDynamic("Roles/GetAll", undefined);
      
        if (dataPermission) {
            let listToCheck = dataPermission.map((perm) => {
              let getRole = roles.filter(x => x.RoleId === perm.roleId);
              return getRole[0];
            });
        
            console.log(listToCheck)
         
            var checkIsAdminRole = listToCheck.filter(x =>  x.RoleId === 1);
            if (checkIsAdminRole.length > 0) 
            {
                isSuperAdmin = true;
                setIsSuperAdmin(isSuperAdmin);
            }

            var deptAdmin = listToCheck.filter(x => x.NameTh.includes(" Admin "));
            if (deptAdmin.length > 0)
            {
                isDeptAdmin = true;
                deptFilterArray = deptAdmin.map( item => {
                    return item.NameTh.split(" Admin ")[0];
                })
                setIsDeptAdmin(isDeptAdmin);
                
            }
            setDeptFilter(deptFilterArray);
        }

    
      };

    const fetchDataMasterBudget = async() => {
        setLoading(true);
        let dataSourceBudget = await GetMasterBudget();
        let tempDataSourceBudget = dataSourceBudget.data;
        if (!isSuperAdmin && isDeptAdmin){

            tempDataSourceBudget = tempDataSourceBudget?.filter(obj => deptFilter.includes(obj["DepartmentCode"]));
        }else if (!isSuperAdmin && !isDeptAdmin){
            tempDataSourceBudget = null;
        }

        setDataSource(tempDataSourceBudget);
        setLoading(false);
    }

    const fetchMasterDepartment = async() => {
        let _data = await GetDepartment();
        
        if (!isSuperAdmin && isDeptAdmin){

            _data = _data.filter(obj => deptFilter.includes(obj["DepartmentCode"]));
        }
        setDataDepartmentList(_data);
    }
    const fetchMasterDivision = async() => {
        let _data = await GetDivision();
        setDataDivisionList(_data);
    }
    const fetchMasterSection = async() => {
        let _data = await GetSection();
        setDataSectionList(_data);
    }

    const bindingValueToDropdown = (ddlType: string, filter?: string) => {
        let distinctSourceData = [];
        let ddlOption:  { value: string; label: string }[] = [];
        switch (ddlType) {
          case "DEP":
            if (dataDepartmentList !== undefined){
                distinctSourceData = dataDepartmentList
                //.filter((item: any) => item.funC_LEVEL == "EVP")
                .map((item: any) => ({
                      value: item.DepartmentCode,
                      label: item.NameTh,
                  }))
                .filter((name: any, index: any, currentVal: any) => currentVal.indexOf(name) === index)
                .sort((a: any, b: any) => (a.label > b.label ? 1 : -1));
            }
            break;
          case "DIV":
            distinctSourceData = dataDivisionList
              .filter((item: any) => item.DepartmentCode === form.getFieldValue("DepartmentCode"))
              .map((item: any) => ({
                    value: item.DivisionCode,
                    label: item.NameTh,
                }))
              .filter((name: any, index: any, currentVal: any) => currentVal.indexOf(name) === index)
              .sort((a: any, b: any) => (a.label > b.label ? 1 : -1));
            break;
          case "SEC":
            distinctSourceData = dataSectionList
              .filter((item: any) => item.DepartmentCode === form.getFieldValue("DepartmentCode") && item.DivisionCode === form.getFieldValue("DivisionCode"))
              .map((item: any) => ({
                    value: item.SectionCode,
                    label: item.SectionName,
                }))
              .filter((name: any, index: any, currentVal: any) => currentVal.indexOf(name) === index)
              .sort((a: any, b: any) => (a.label > b.label ? 1 : -1));
            break;
        }
        if (distinctSourceData.length > 0) ddlOption.push({ value: "", label: "" }); //set default values
        distinctSourceData.map((item: any) => {
          ddlOption.push(item);
        });
    
        //console.table(ddlOption);
        return ddlOption;
      };

    const [form] = Form.useForm();
    interface IKeys { key1: string; key2: string }

    let departmentOptions: { value: string; label: string }[] = [];

    if (dataDepartmentList != undefined) {
        departmentOptions = dataDepartmentList.map((item: any) => ({
            value: item.DepartmentCode,
            label: item.NameTh,
        }));
    }
    let divisionOptions: { value: string; label: string }[] = [];

    if (dataDivisionList != undefined) {
        divisionOptions = dataDivisionList.map((item: any) => ({
            value: item.DivisionCode,
            label: item.NameTh,
        }));
        divisionOptions = Array.from(
            new Map(divisionOptions.map(item => [item.value, item])).values()
          );
    }

    let sectionOptions: { value: string; label: string }[] = [];

    if (dataSectionList != undefined) {
        sectionOptions = dataSectionList.map((item: any) => ({
            value: item.SectionCode,
            label: item.SectionName,
        }));

        sectionOptions = Array.from(
            new Map(sectionOptions.map(item => [item.value, item])).values()
          );
    }

    const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndex,
      ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
      };
    
      const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
      };
      const getColumnSearchProps = (dataIndex: DataIndex, placeholder: string) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`ค้นหา ${placeholder}`}
                    value={`${selectedKeys[0] || ''}`}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) => {
            return record[dataIndex] != null && record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase())
        },
        //onFilterDropdownOpenChange: visible => {
        //    if (visible) {
        //        setTimeout(() => searchInput.current?.select(), 100);
        //    }
        //},
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    const columns: ColumnsType<DataType> = [
        {
            title: 'Budget Year',
            dataIndex: 'BudgetYear',
            key: 'BudgetYear',
            width: "10%",
            ...getColumnSearchProps('BudgetYear', 'BudgetYear')
          },
        {
          title: 'หน่วยงาน',
          dataIndex: 'DepartmentName',
          key: 'DepartmentName',
          width: "15%",
          ...getColumnSearchProps('DepartmentName', 'หน่วยงาน')
        },
        {
            title: 'ฝ่าย',
            dataIndex: 'DivisionName',
            key: 'DivisionName',
            width: "15%",
            ...getColumnSearchProps('DivisionName', 'ฝ่าย')
          },
          {
            title: 'งาน',
            dataIndex: 'SectionName',
            key: 'SectionName',
            width: "15%",
            ...getColumnSearchProps('SectionName', 'งาน')
          },
        
        {
            title: 'TotalBudget',
            dataIndex: 'TotalBudget',
            key: 'TotalBudget',
            width: "10%",
            //...getColumnSearchProps('ItemIdString', 'สินค้าที่ต้องการแสดง')
            render: (text) => {
                var checkData = text != null ? parseFloat(text).toFixed(2) : 0.00;
                var textData = checkData === "0.00" ? "-" : checkData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return <div style={{textAlign: "right"}}>{textData}</div>;
            }
          },
          {
            title: 'CurrentBudget',
            dataIndex: 'CurrentBudget',
            key: 'CurrentBudget',
            width: "10%",
            //...getColumnSearchProps('ItemIdString', 'สินค้าที่ต้องการแสดง')
            render: (text) => {
                var checkData = text != null ? parseFloat(text).toFixed(2) : 0.00;
                var textData = checkData === "0.00" ? "-" : checkData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return <div style={{textAlign: "right"}}>{textData}</div>;
            }
          },
          {
            title: 'IsUnLimit',
            dataIndex: 'IsUnLimit',
            key: 'IsUnLimit',
            //...getColumnSearchProps('ItemIdString', 'สินค้าที่ต้องการแสดง')
            render: (text) => {
                
                return <div style={{textAlign: "center"}}>{text ? "Yes" : "No"}</div>;
            }
          },
        {
            title: '#',
            key: 'action',
            width: "12%",
            render: (_, record) => (
                <Space>
                     <Button
                type="primary"
                onClick={() => {
                    let checkYear = dayjs(record.BudgetYear + '-01-01').locale(th).add(-543, "year")//.isValid();
                    //dayjs(monthParam + "-01").locale(th).format('MMMM BBBB');
                    let itemEdit:Values = {
                        BudgetID : record.BudgetID,
                        DepartmentCode: record.DepartmentCode,
                        DivisionCode: record.DivisionCode,
                        SectionCode: record.SectionCode,
                        IsUnLimit: record.IsUnLimit,
                        TotalBudget: record.TotalBudget,
                        CurrentBudget: record.CurrentBudget,
                        BudgetYear: checkYear,//record.BudgetYear != "" ?? dayjs(record.BudgetYear + ""),
                        IsActive: record.IsActive,
                        CreatedBy: userData.EmployeeId.toString(),
                        ModifiedBy: userData.EmployeeId.toString()
                    }
                    //setDataSourceDetail(itemEdit);
                    form.setFieldsValue(itemEdit);
                    setOpenPopupEdit(true);
                    setDivisionSource(bindingValueToDropdown("DIV"));
                    setSectionSourcee(bindingValueToDropdown("SEC"));
                }}
            >
                แก้ไขข้อมูล
            </Button>
            <Button
                type="primary"
                onClick={async () => {
                    await onDeleteItemClick(record);
                }}
            >
                ลบข้อมูล
            </Button>
                </Space>
               
            
            ),
          },
      ];
      
    return (
        <>
             <Layout>
        <Content className={styles.contents}>
          <div className={styles.content_header}>
            <p className={`${styles.p_tag} ${styles.header}`}>ข้อมูลงบประมาณ</p>
            <Button
                type="primary"
                onClick={() => {
                    setOpenPopupEdit(true);
                }}
            >
                เพิ่มข้อมูล
            </Button>
            <Modal
            visible={openPopupEdit}
            className={styles.modal_detail}
            title="จัดการงบประมาณ"
            okText="บันทึก"
            cancelText="ยกเลิก"
            closable={false}
            maskClosable={false}
            loading={loading}
            confirmLoading={confirmLoading}
            onCancel={() => {
                //onPopupCreate(false);
                let itemEdit:Values = {};
                //setDataSourceDetail(itemEdit);
                form.setFieldsValue(itemEdit);
                form.resetFields();
                setOpenPopupEdit(false);
            }}
            onOk={() => {
                form
                    .validateFields()
                    .then(values => {
                        onPopupCreate(values);
 
                    })
                    .catch(info => {
                        console.log('Validate Failed:', info);
                    });
            }}
        >
            <Form
                form={form}
                layout="vertical"
                name="form_in_modal"
                initialValues={dataSourceDetail}
                preserve={false}
            >
                <Form.Item hidden name="BudgetID">
                    <Input type="hidden" />
                </Form.Item>
                <Form.Item name="DepartmentCode" label="หน่วยงาน">
                    <Select className="auto_control_backdate" key={"department"}
                        size="large"
                        showSearch
                        style={{ width: 200 }}
                        placeholder="เลือกหน่วยงาน"
                        optionFilterProp="children"
                        filterOption={(input, option) => (option?.label ?? '').includes(input)}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={departmentSource}
                        onChange={(value, option) => { 
                            setDivisionSource(bindingValueToDropdown("DIV")); 
                            setSectionSourcee(bindingValueToDropdown("SEC"));
                            form.setFieldsValue({
                                DivisionCode: '',
                                SectionCode: ''
                            })
                        }}
                    />
                </Form.Item>
                <Form.Item name="DivisionCode" label="ฝ่าย">
                    <Select className="auto_control_backdate" key={"division"}
                        size="large"
                        showSearch
                        style={{ width: 200 }}
                        placeholder="เลือกฝ่าย"
                        optionFilterProp="children"
                        filterOption={(input, option) => (option?.label ?? '').includes(input)}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={divisionSource}
                        onChange={(value, option) => { setSectionSourcee(bindingValueToDropdown("SEC")); 
                            form.setFieldsValue({
                                SectionCode: ''
                            })
                        }}
                    />
                </Form.Item>
                <Form.Item name="SectionCode" label="งาน">
                    <Select className="auto_control_backdate" key={"section"}
                        size="large"
                        showSearch
                        style={{ width: 200 }}
                        placeholder="เลือกงาน"
                        optionFilterProp="children"
                        filterOption={(input, option) => (option?.label ?? '').includes(input)}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={sectionSource}
                    />
                </Form.Item>
                <Form.Item name="BudgetYear" label="BudgetYear">
                    <DatePicker
                            locale={datePickerTh}
                            format="BBBB"
                            picker="year" 
                        />
                </Form.Item>
                <Form.Item name="TotalBudget" label="TotalBudget">
                <InputNumber style={{ width: '100%' }}
                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    />
                </Form.Item>
                <Form.Item name="CurrentBudget" label="CurrentBudget">
                <InputNumber style={{ width: '100%' }}
                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    />
                </Form.Item>
                <Form.Item name="IsUnLimit" label="IsUnLimit" valuePropName="checked">
                    <Switch  />
                </Form.Item>
                <Form.Item name="IsActive" label="IsActive" valuePropName="checked">
                    <Switch />
                </Form.Item>
            </Form>
        </Modal>

          </div>
          <Table rowKey={record => record.BudgetID}
                    className={'main-table-salary'}
                    bordered
                    dataSource={dataSource}
                    columns={columns} /*scroll={{ x: 4000, y: 700 }}*/ loading={loading}
                    pagination={{ position: ['bottomCenter'] }}

                />
        </Content>
      </Layout>

          
        </>
    );
}
export default MasterBudget;
